import { Link } from 'react-router-dom';
import { accentBg } from '../data/products';
import { useCart } from '../context/CartContext';
import { useCurrency } from '../context/CurrencyContext';

export const ProductCard = ({ product, index = 0 }) => {
  const { addItem } = useCart();
  const { format } = useCurrency();
  const savings = product.single_price * product.pack_count - product.pack_price;

  return (
    <div
      className="group animate-fade-up flex flex-col h-full"
      style={{ animationDelay: `${index * 120}ms` }}
      data-testid={`product-card-${product.id}`}
    >
      <Link to={`/product/${product.slug}`} className="block">
        <div className={`aspect-[4/5] ${accentBg(product.accent, true)} overflow-hidden mb-6 relative`}>
          <img
            src={product.image}
            alt={product.name}
            className="w-full h-full object-contain p-6 transition-transform duration-700 ease-out group-hover:scale-105"
          />
          <span className="absolute top-4 left-4 text-[10px] uppercase tracking-[0.22em] bg-lum-bg/90 px-3 py-1">
            Save {format(savings)}
          </span>
        </div>
      </Link>
      <div className="flex items-baseline justify-between gap-4">
        <div className="min-h-[80px]">
          <p className="overline text-lum-muted">{product.concern}</p>
          <Link to={`/product/${product.slug}`}>
            <h3 className="font-serif-display text-2xl md:text-3xl mt-1 leading-tight">{product.name}</h3>
          </Link>
        </div>
        <div className="text-right">
          <p className="text-sm text-lum-muted">{product.pack_count} pcs</p>
          <p className="text-base">{format(product.pack_price)}</p>
        </div>
      </div>
      <p className="text-sm text-lum-text2 mt-2 line-clamp-2 min-h-[40px]">{product.short_description}</p>
      <div className="mt-5 flex gap-3 mt-auto pt-5">
        <button
          data-testid={`quick-add-pack-${product.id}`}
          onClick={() => addItem({ product, packSize: 'pack' })}
          className="btn-primary flex-1"
        >
          Add Pack — {format(product.pack_price)}
        </button>
        <Link
          to={`/product/${product.slug}`}
          data-testid={`view-product-${product.id}`}
          className="btn-secondary"
        >
          View
        </Link>
      </div>
    </div>
  );
};
